import { Info } from '@ui/components/icons';
import { TextTooltip } from '@ui/components/TextTooltip';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text, TextProps } from '@ui/lib/park/ui/text';
import { isNil } from 'lodash-es';
import { TFunction, useTranslation } from 'next-i18next';
import { css } from 'styled-system/css';
import { SystemStyleObject } from 'styled-system/types';

import { LiquidationStatus } from './utils/getLiquidationStatus';

export const LiquidationStatusBadge = ({
  status,
  ...props
}: TextProps & {
  status: LiquidationStatus | undefined;
}) => {
  const { t } = useTranslation();

  if (isNil(status)) return null;

  return (
    <TextTooltip
      content={
        <Text textStyle="textParagraph.small">
          {getTooltipsContent(t, status)}
        </Text>
      }
    >
      <Text
        css={{
          display: 'inline-flex',
          // #22: icon rides the text centerline — no baseline drift
          alignItems: 'center',
          gap: '4px',
          lineHeight: '14px',
          textStyle: 'v2.meta',
          width: 'fit-content',
          ...COLOR_MAP[status],
        }}
        {...props}
      >
        {LABEL_MAP[status]}
        <Icon boxSize="3.5">
          <Info />
        </Icon>
      </Text>
    </TextTooltip>
  );
};
const LABEL_MAP: Record<LiquidationStatus, string> = {
  Safe: 'Healthy',
  Cautious: 'Warning',
  Critical: 'Risky',
};

const getTooltipsContent = (t: TFunction, status: LiquidationStatus) => {
  return {
    [LiquidationStatus.Safe]: t(
      'Position maintains healthy margin buffer above liquidation threshold',
    ),
    [LiquidationStatus.Cautious]: t(
      'Position margin is declining toward liquidation threshold',
    ),
    [LiquidationStatus.Critical]: t(
      'Position margin is critically close to liquidation threshold',
    ),
  }[status];
};

const COLOR_MAP: Record<LiquidationStatus, SystemStyleObject> = {
  Safe: css.raw({ color: 'v2.long.default' }),
  Cautious: css.raw({ color: 'v2.warning' }),
  Critical: css.raw({ color: 'v2.short.default' }),
};
